import { render, staticRenderFns } from "./WikiAllowedIPAddressConfig.vue?vue&type=template&id=33427ea0"
import script from "./WikiAllowedIPAddressConfig.vue?vue&type=script&lang=ts"
export * from "./WikiAllowedIPAddressConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports